export interface Place {
  id: string; // Guid en C# se mapea a string en TypeScript
  name: string;
  description: string;
  lat: number;
  longi: number;
  price?: Price; // Price es opcional en C#, por lo que se marca como opcional en TypeScript
  placeType?: PlaceType; // PlaceType es opcional en C#, por lo que se marca como opcional en TypeScript
  webSite: string;
  direccion: string;
  calificacion?: number; // Calificacion es opcional en C#, por lo que se marca como opcional en TypeScript
  urlGoogle: string;
  horarios: string[]; // Arreglo de strings
  fotos: string[]; // Arreglo de strings
  aprobado: boolean; // Aprobado es un booleano
  bajoTecho: boolean; // Indica si el lugar es bajo techo / apto para días de lluvia
  fechaFin?: string | null; // Si está seteada, el lugar deja de mostrarse pasada esta fecha (lugares temporales)
}

export enum PlaceType {
  Plaza = "Plaza",
  ParqueTematico = "ParqueTematico",
  Campo = "Campo",
  JuegosNiños = "JuegosNiños",
  CamasElasticas = "CamasElasticas",
  ParqueAcuatico = "ParqueAcuatico",
  Museo = "Museo",
  Granja = "Granja",
  ParqueNatural = "ParqueNatural",
  EscapeRooms = "EscapeRooms",
  Restaurante = "Restaurante",
  Zoologicos = "Zoologicos",
  Cine = "Cine",
  Arcade = "Arcade",
  Shopping = "Shopping"
} 
export enum Price {
  Gratis = "Gratis",
  Economico = "Economico",
  Moderado = "Moderado",
  Costoso = "Costoso",
}
export interface Category {
  label: string;
  icon: string;
}

export const categoryMapping = {
  Plaza: 'Plaza',
  ParqueTematico: 'Parque Temático',
  Campo: 'Campo',
  JuegosNiños: 'Juegos para Niños',
  CamasElasticas: 'Camas Elásticas',
  ParqueAcuatico: 'Parque Acuático',
  Museo: 'Museo',
  Granja: 'Granja',
  ParqueNatural: 'Parque Natural',
  EscapeRooms: 'Escape Rooms',
  Restaurante: 'Restaurante',
  Zoologicos: 'Zoológicos',
  Cine: 'Cine',
  Arcade: 'Arcade',
  Shopping: 'Shopping',
};